import AuthenticationResource from '@ane/exp-data/lib/resources/AuthenticationResources';
import { getDefaultAsyncWrapperObj } from '@ane/core/lib/models';
import { loadResourcesUtils } from '@ane/core/lib/utils/LoadResourcesUtils';
export const defaultReducerState = {
    res: getDefaultAsyncWrapperObj(),
};
// Action Types
const prefix = 'loadManagedIdentityNameList';
const CLEAR_DATA_SOURCE_STATE = `${prefix}/CLEAR_STATE`;
export const clearLoadManagedIdentityNameListState = () => ({
    type: CLEAR_DATA_SOURCE_STATE,
});
const loadManagedIdentityNameListArgs = {
    actionPrefix: `${prefix}/LOAD`,
    reduxKeyNested: () => ['res'],
    loadResource: (inputPayload) => {
        return AuthenticationResource.getManagedIdentityNameList(inputPayload.workspaceId);
    },
    onCompleteSuccess: (resourceResult) => {
        return resourceResult;
    },
};
export const loadManagedIdentityNameListEpicReducer = loadResourcesUtils(loadManagedIdentityNameListArgs);
// Reducer
export const loadManagedIdentityNameListReducer = (state = defaultReducerState, action) => {
    switch (action.type) {
        case CLEAR_DATA_SOURCE_STATE:
            return defaultReducerState;
        default:
            return loadManagedIdentityNameListEpicReducer.reduxChange(state, action);
    }
};
export default loadManagedIdentityNameListReducer;

//# sourceMappingURL=ManagedIdentityList.ducks.js.map
